module.exports = __webpack_public_path__ + "@/assets/img/bot2.a16f3fc2.png";